<template>
  <v-content>
    <v-container fluid>
      <Header :title="title" />
      <v-row no-gutters>
        <v-col cols="12">
           <v-tabs
              v-model="tabs"
            >
              <v-tabs-slider></v-tabs-slider>
              <v-tab v-if="canAdd" href="#viewsystemmailstab" active> {{ 'System Emails' | translate}} </v-tab>
              <v-tab v-if="canAddScheduled" href="/scheduled-mail-notification"> {{ 'Scheduled Mails' | translate}} </v-tab>
              <v-tab  v-if="canAddTriggered" href="/trigger-mail-template"> {{ 'Trigger Mails' | translate }} </v-tab>
              <v-tab v-if="canAddReminder"  href="/reminder"> {{ 'Reminder Mails' | translate }} </v-tab>
          </v-tabs>
          <DataTable
            @editing="editing"
            @deleting="deleting"
            :title="''"
            :headers="headers"
            :items="emailtemplates"
            :search="search"
          />
        </v-col>
        <Dialogbox
          @closing="closing"
          @deleteuser="deleteQuestion"
          :title="dialogboxtitle"
          :dialog="dialogstatus"
          :buttonTitle="dialogButtontitle"
          :deleteuser="true"
          v-if="dialogstatus"
        />
      </v-row>
    </v-container>
    <v-btn dark fab fixed bottom right large color="pink" class="mx-2" v-if="canAdd" @click="addCustomEmailTemplate">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </v-content>
</template>

<script>
import { mapGetters } from "vuex"
import store from "@/store"
import {
  FETCH_EMAIL_TEMPLATES,
  DELETE_EMAIL_TEMPLATE,
  RESET_STATE
} from "@/store/actions.type";
import { SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type"
export default {
  name: "CustomMail",
  beforeRouteEnter(to, from, next) {
    store.dispatch(RESET_STATE)
    return next();
  },
  beforeRouteLeave(to, from, next) {
    store.dispatch(RESET_STATE)
    next();
  },
  data: function() {
    return {
      title: "System Emails",
      search: "",
      dialogstatus: false,
      dialogButtontitle: null,
      dialogboxtitle: null,
      questionid: null,
      singleSelect: "",
      dialog: false,
      tabs:"viewsystemmailstab"
    };
  },
  components: {
    DataTable: () => import("@/components/datatable/datatable"),
    Dialogbox: () => import("@/components/dialog/dialog"),
    Header: () => import("@/components/header/Header")
  },
  computed: {
    ...mapGetters(["emailtemplates",'currentUser']),
    headers () {
      return [
        { text: this.$t("Email Template id"), value: "id" },  
        { text: this.$t("Template Name"), value: "mail_template_name" },        
        { text: this.$t("Type"), value: "mailable" },        
        { text: this.$t("Language"), value: "mail_language" },        
        { text: this.$t("Custom Email Subject"), value: "subject" },        
        { text: this.$t("Actions"), value: "action", sortable: false }
      ]
    },
    canAdd(){
      if(typeof (this.currentUser) !== 'undefined') {
        if(this.currentUser.roles.includes(1) || this.currentUser.permissions.includes('has-access-to-system-mails')){
          return true;
        }
      }
      return false;
    },
    canAddScheduled(){
      if(typeof (this.currentUser) !== 'undefined') {
        if(this.currentUser.roles.includes(1) || this.currentUser.permissions.includes('has-access-to-scheduled-mails')){

          return true;
        }
      }
      return false;
    },
    canAddTriggered(){
      if(typeof (this.currentUser) !== 'undefined') {
        if(this.currentUser.roles.includes(1) || this.currentUser.permissions.includes('has-access-to-trigger-mails')){

          return true;
        }
      }
      return false;
    },
    canAddReminder(){
      if(typeof (this.currentUser) !== 'undefined') {
        if(this.currentUser.roles.includes(1) || this.currentUser.permissions.includes('has-access-to-reminder-mails')){

          return true;
        }
      }
      return false;
    },
  },
  created(){
    let companytype = this.currentUser.company ? this.currentUser.company.account_type : 'all';
    store.dispatch(FETCH_EMAIL_TEMPLATES, "?show="+companytype).then(resp => {
      if (resp.success) {
        store.commit(SET_LOADING, false)
        store.commit(SET_ROUTER_ENTER, false)
      }
    });
  },
  methods: {
    addCustomEmailTemplate() {
      this.$router.push("/system-email-template/add");
    },
    editing(id) {
      this.$router.push("/system-email-template/edit/" + id)
    },
    deleting(id) {
      this.dialogstatus = true
      this.dialogboxtitle = "Are you sure want to remove?"
      this.dialogButtontitle = "Remove"
      this.questionid = id
    },
    async deleteQuestion() {
      await this.$store
        .dispatch(DELETE_EMAIL_TEMPLATE, this.questionid)
        .then(async resp => {
          if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
            this.questionid = null;
            await store.dispatch(FETCH_EMAIL_TEMPLATES, "").then(resp => {
              if (resp.success) {
                store.commit(SET_LOADING, false);
                this.dialogstatus = false;
              }
            });
          }
          else{
            store.commit(SET_LOADING, false);
          }
        });
    },
    closing() {
      this.dialogstatus = false
    },
  }
};
</script>